import type { ComponentProps, PropsWithChildren } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { DisplayProps } from 'styled-system';
import { display } from 'styled-system';

import type { StateType } from '../../../enums/StateType';
import { Flex } from '../../Flex';
import { CaptionRegularCR1 } from '../../Typography';
import StateIcon from './StateIcon';
import { getStateTextColor } from './utils';

interface StateMessageProps extends PropsWithChildren {
  id?: string;
  withIcon?: boolean;
  type: StateType;
  color?: ComponentProps<typeof CaptionRegularCR1>['color'];
}

const Message = styled(CaptionRegularCR1)<DisplayProps>`
  ${display};
`;

const StateMessage = ({ id, type, withIcon, color, children }: StateMessageProps) => (
  <Flex
    as="li"
    alignItems="center"
    mb={withIcon ? 'sp_0' : 'sp_4'}
    ml={withIcon ? 'sp_0' : 'sp_16'}
  >
    {withIcon && <StateIcon mr="sp_4" type={type} />}
    <Message
      id={id}
      as="span"
      display="block"
      data-testid="state-message"
      color={color ?? getStateTextColor(withIcon ? null : type)}
    >
      {children}
    </Message>
  </Flex>
);

export default StateMessage;
